import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { SubmitButton } from '@/components/ui/app/submit-button';
import { BackButton } from '@/components/ui/app/back-button';
import { Input } from '@/components/ui/input';
import { ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '@/lib/contexts/auth-context';
import { getErrorMessage } from '@/lib/utils/validation-errors';
import { useTranslation } from 'react-i18next';

export function LoginForm({ onBack, onSwitchToRegister, onSwitchToForgotPassword }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { login } = useAuth();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            await login({ email, password });
            navigate('/dashboard');
        } catch (error) {
            const message = getErrorMessage(error, t('welcome:loginFailed'));
            toast.error(message.split('\n')[0]); // Show first error in toast
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="relative flex flex-col min-h-full">
            <div className="shrink-0">
                <BackButton onClick={onBack} />
            </div>

            <div className="flex flex-col items-center justify-center flex-1 max-w-md mx-auto w-full py-8">
                <h2 className="text-4xl font-black mb-8 text-center">{t('welcome:seConnecter')}</h2>

                <form className="w-full space-y-4" onSubmit={handleSubmit}>
                    <Input
                        type="email"
                        placeholder={t('welcome:email')}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <Input
                        type="password"
                        placeholder={t('welcome:motDePasse')}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />

                    <div className="text-right">
                        <Button
                            type="button"
                            variant="link"
                            color="secondary"
                            className="text-sm font-medium p-0 h-auto"
                            onClick={onSwitchToForgotPassword}
                        >
                            {t('welcome:motDePasseOublie2')}
                        </Button>
                    </div>

                    <SubmitButton
                        isSubmitting={isSubmitting}
                        loadingText={t('welcome:connexion')}
                        color="primary"
                        size="cta"
                        className="w-full mt-6"
                    >
                        {t('welcome:seConnecter')}
                    </SubmitButton>
                </form>

                <p className="mt-6 text-muted-foreground">
                    {t('welcome:pasEncoreDeCompte')}{' '}
                    <Button
                        variant="link"
                        color="secondary"
                        onClick={onSwitchToRegister}
                        className="font-medium p-0 h-auto"
                    >
                        {t('welcome:creerUnCompte')}
                    </Button>
                </p>
            </div>
        </div>
    );
}
